export { SelectWeightController as SelectWeight } from './select-weight.controller';
